import { normalize } from "../../components/Topics/Modal/Flow/Collision/constants";
import type { KeywordsGroupsSchema } from "../../hooks/useKeywordsGroups";

export const getUniqKwNames = (keywordsGroups: KeywordsGroupsSchema) => {
    const set = new Set<string>();

    const push = (txt?: string) => {
        if (!txt) {
            return;
        }
        const n = normalize(txt);
        if (n) {
            set.add(n);
        }
    };

    keywordsGroups?.sharedKWList?.forEach((g) => push(g.text));
    keywordsGroups?.ownKWList?.forEach((g) => push(g.text));

    return set;
};
